module.exports = __webpack_public_path__ + "static/media/Phone.76a8d6c3.svg";